import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';

import {
  entityTiposDocumentoLoadFailure,
  entityTiposDocumentoLoadSuccess,
  entityTiposDocumentoLoadRequest
} from './entity-tipos-documento.actions';
import { TiposDocumentoService } from '@rpe/registro-personas-empresas-lib/src/lib/tipos-documento/tipos-documento.service';

@Injectable()
export class TiposDocumentoEffects {
  // load
  loadRequestTiposDocumento = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTiposDocumentoLoadRequest),
      mergeMap(() =>
        this.tiposDocumentoServiceService.getTiposDocumento().pipe(
          map((items) => entityTiposDocumentoLoadSuccess({ items })),
          catchError((error) => of(entityTiposDocumentoLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private tiposDocumentoServiceService: TiposDocumentoService
  ) {
    this.tiposDocumentoServiceService.url = environment.apiUrl;
  }
}
